import {Edge, Node, Position} from '@xyflow/react';
import {ERFEdge, ERFElement, TRFGraphDataConfig} from '@progress-fe/rf-core';
import {EElement, ELogicalElement} from '@progress-fe/core';
import {v4 as uuidv4} from 'uuid';

const DEFAULT_X = 230;
const DEFAULT_Y = 60;
const X_STEP = 184;
const Y_STEP = 65;

export const GRAPH_LIST: {
  projectId: string;
  projectName: string;
  nodes: Node<TRFGraphDataConfig, ERFElement>[];
  edges: Edge[];
}[] = [
  {
    projectId: '47CB2F0C-0000-0000-0000-000000000001',
    projectName: 'Схема с сепараторами (моковый проект)',
    nodes: [
      {
        id: '196C89E0-0000-0000-0000-000000000008', // 1
        type: ERFElement.Element,
        data: {
          isSourceHandle: true,
          elementType: EElement.MaterialFlowElement,
          title: '1',
          subTitle: 'Пенг-Робинсон-1',
          recycleHandle: {position: Position.Left, type: 'target'}
        },
        position: {x: DEFAULT_X, y: DEFAULT_Y},
        deletable: false
      },
      {
        id: '196C89E0-0000-0000-0000-000000000001', // V-100
        type: ERFElement.Element,
        data: {
          isTargetHandle: true,
          isSourceHandle: true,
          elementType: EElement.TwoPhaseSeparatorElement,
          title: 'V-100',
          subTitle: 'Сеп 2-фазный-1'
        },
        position: {x: DEFAULT_X, y: DEFAULT_Y + Y_STEP},
        deletable: false
      },
      {
        id: '196C89E0-0000-0000-0000-000000000009', // 2
        type: ERFElement.Element,
        data: {
          isTargetHandle: true,
          isSourceHandle: true,
          elementType: EElement.MaterialFlowElement,
          title: '1',
          subTitle: 'Пенг-Робинсон-1',
          recycleHandle: {position: Position.Left, type: 'source'}
        },
        position: {x: DEFAULT_X, y: DEFAULT_Y + Y_STEP * 2},
        deletable: false
      },
      {
        id: '196C89E0-0000-0000-0000-000000000006', // Q-100
        type: ERFElement.Element,
        data: {
          isSourceHandle: true,
          elementType: EElement.EnergyFlowElement,
          title: 'Q-100'
        },
        position: {x: DEFAULT_X + X_STEP, y: DEFAULT_Y + Y_STEP * 2},
        deletable: false
      },
      {
        id: '196C89E0-0000-0000-0000-000000000002', // K-100
        type: ERFElement.Element,
        data: {
          isTargetHandle: true,
          elementType: EElement.CompressorElement,
          title: 'К-100',
          subTitle: 'Компрессор-1'
        },
        position: {x: DEFAULT_X, y: DEFAULT_Y + Y_STEP * 3},
        deletable: false
      },
      /* RECYCLES */
      {
        id: '196C89E0-0000-0000-0000-0000000000R1', // R1
        type: ERFElement.Recycle,
        data: {
          templateCode: 'default' // or 'filled'
        },
        position: {x: 80, y: 100},
        deletable: false
      },
      /* LOGICAL ELEMENTS */
      {
        id: '196C89E0-0000-0000-0000-0000000000F1', // F1
        type: ERFElement.Function,
        data: {
          templateCode: 'default'
        },
        position: {x: DEFAULT_X, y: DEFAULT_Y + Y_STEP * 4},
        deletable: false
      },
      {
        id: '196C89E0-0000-0000-0000-0000000000F2', // F2
        type: ERFElement.Element,
        data: {
          isTargetHandle: true,
          logicalElementType: ELogicalElement.Function,
          title: 'F-100',
          subTitle: 'Функция-1'
        },
        position: {x: DEFAULT_X, y: DEFAULT_Y + Y_STEP * 5},
        deletable: false
      }
    ],
    edges: [
      {
        id: uuidv4(),
        type: ERFEdge.Default,
        source: '196C89E0-0000-0000-0000-000000000008', // 1
        target: '196C89E0-0000-0000-0000-000000000001', // V-100
        sourceHandle: 'source_default',
        targetHandle: 'target_default',
        deletable: false
      },
      {
        id: uuidv4(),
        type: ERFEdge.Default,
        source: '196C89E0-0000-0000-0000-000000000001', // V-100
        target: '196C89E0-0000-0000-0000-000000000009', // 2
        sourceHandle: 'source_default',
        targetHandle: 'target_default',
        deletable: false
      },
      {
        id: uuidv4(),
        type: ERFEdge.Default,
        source: '196C89E0-0000-0000-0000-000000000006', // Q-100
        target: '196C89E0-0000-0000-0000-000000000002', // K-100
        sourceHandle: 'source_default',
        targetHandle: 'target_default',
        deletable: false
      },
      {
        id: uuidv4(),
        type: ERFEdge.Default,
        source: '196C89E0-0000-0000-0000-000000000009', // 2
        target: '196C89E0-0000-0000-0000-000000000002', // K-100
        sourceHandle: 'source_default',
        targetHandle: 'target_default',
        deletable: false
      },
      /* RECYCLES */
      {
        id: uuidv4(),
        type: ERFEdge.Recycle,
        source: '196C89E0-0000-0000-0000-0000000000R1', // R1
        target: '196C89E0-0000-0000-0000-000000000008', // 1
        sourceHandle: 'source_recycle',
        targetHandle: 'target_recycle',
        deletable: false
      },
      {
        id: uuidv4(),
        type: ERFEdge.Recycle,
        source: '196C89E0-0000-0000-0000-000000000009', // 2
        target: '196C89E0-0000-0000-0000-0000000000R1', // R1
        sourceHandle: 'source_recycle',
        targetHandle: 'target_recycle',
        deletable: false
      }
    ]
  }
];
